import { render } from "./BenefitIcons.vue?vue&type=template&id=16c1c74a&scoped=true"
import script from "./BenefitIcons.vue?vue&type=script&lang=js"
export * from "./BenefitIcons.vue?vue&type=script&lang=js"

import "./BenefitIcons.vue?vue&type=style&index=0&id=16c1c74a&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16c1c74a"]])

export default __exports__